import { ReactNode } from "react";
import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  Text,
} from "@chakra-ui/react";
import { gql } from "__generated__/gql";
import BrandEmails from "components/Shared/BrandEmails";
import BrandName from "components/Shared/BrandName";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { APP_NAME } from "utils/config";
import { useCurrentBrandId } from "utils/currentUserHooks";

const query = gql(/* GraphQL */ `
  query BrandEmailInboxAddressesContent($brandId: UUID!) {
    brand(id: $brandId) {
      id
      ...BrandEmailsFields
    }
  }
`);

type Props = ModalContentProps & {
  hasCloseButton?: boolean;
  heading: ReactNode;
};

export default function BrandEmailAddressesModalContent({
  hasCloseButton = true,
  heading,
  ...rest
}: Props) {
  const brandId = useCurrentBrandId();
  const { data, loading } = useBrandQuery(query, {
    variables: brandId ? { brandId } : undefined,
    skip: !brandId,
  });

  return (
    <ModalContent {...rest}>
      <ModalHeader color="magenta.veryDark">{heading}</ModalHeader>
      {hasCloseButton && <ModalCloseButton />}

      <ModalBody pb={6}>
        <Text mb={6}>
          Email messages may be sent to the {APP_NAME} inbox for{" "}
          <BrandName fallback="this account" /> by using the appropriate email
          address below:
        </Text>

        <BrandEmails brand={data?.brand} isLoading={loading} />
      </ModalBody>
    </ModalContent>
  );
}
